// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import Chevron_left from '../../../../hola/pub/img/hola2023/icons/16/chevron_left.svg';
import styles from './slider.module.less';

type t_slide = {
  content: React.ReactNode;
  disabled?: boolean;
};

type t_slider_props = {
    wrapper_cls?: string;
    button_cls?: string;
    slides: t_slide[];
    selected_idx?: number;
    select_slide: (n:number)=>void;
};

export const Slider = ({
    wrapper_cls, slides, selected_idx, select_slide}: t_slider_props)=>{
    return <div className={cn(wrapper_cls, styles.wrapper)}>
      <section className={styles.dots_container}>
        {selected_idx>0 && <button className={styles.btn_back}
          onClick={()=>select_slide(selected_idx-1)}>
          <Chevron_left />
        </button>}
        {slides.map((s, idx)=><button
          disabled={s.disabled}
          className={cn(styles.dot, selected_idx==idx && styles.active)}
          key={`btn_${idx}`} onClick={()=>select_slide(idx)}/>)}
      </section>
      <section className={styles.slides_container}>
        {slides.map((s, idx)=><div key={idx}
          className={cn(styles.slide, selected_idx==idx && styles.active)}
          >{selected_idx==idx && s.content}</div>)}
      </section>
    </div>;
};
